import React, { FC } from "react";

import { CompletionStep, CompletionStepProps } from "../../components/setup/CompletionStep";
import { ClientApp } from "models/App";

export interface CompletionStepContainerProps extends Omit<CompletionStepProps, "onNext"> {
    app?: ClientApp;
    onNext(): void;
}

export const CompletionStepContainer: FC<CompletionStepContainerProps> = (props) => {
    const { app, onNext, ...restProps } = props;

    const handleNext = () => {
        // No additional processing needed for completion step
        // Just redirect to dashboard
        onNext();
    };

    return <CompletionStep {...restProps} app={app} onNext={handleNext} />;
};
